<template>
	<div class='detail-box'>
		<div class="input-box">
			<span>将字段：</span>
			<el-select
				v-model="type"
				size="small">
				<el-option
					label="订货周期"
					value="0">
				</el-option>
				<el-option
					label="订货时间"
					value="1">
				</el-option>
			</el-select>
		</div>
		<div class="input-box" v-show="type === '0'">
			<span>修改为：</span>
			<el-select
				v-model="orderGoodsType"
				size="small">
				<el-option
					label="每天订货"
					:value="0">
				</el-option>
				<el-option
					label="每周固定日"
					:value="1">
				</el-option>
				<el-option
					label="每月固定日"
					:value="2">
				</el-option>
				<el-option
					label="每隔几天"
					:value="3">
				</el-option>
			</el-select>
			<el-tooltip effect="dark" :content="weekTooltip === '' ? '请选择' : weekTooltip" placement="top" v-if="type === '0' && orderGoodsType === 1">
				<el-select
					v-model="orderGoodsDate"
					size="small"
					multiple
					collapse-tags
					style="margin-left: 20px;"
					@change="selectWeek"
					placeholder="请选择">
					<div class="select-btn-box">
						<el-button type="primary" size="mini" @click="allSelect('week')">全选</el-button>
						<el-button size="mini" @click="cancelSelect()">取消全选</el-button>
					</div>
					<el-option
						v-for="item in weekDate"
						:key="item.value"
						:label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-tooltip>
			<el-tooltip effect="dark" :content="timeTooltip === '' ? '请选择' : timeTooltip" placement="top" v-if="type === '0' && orderGoodsType === 2">
				<el-select
					v-model="orderGoodsDate"
					size="small"
					multiple
					collapse-tags
					style="margin-left: 20px;"
					@change="selectTime"
					placeholder="请选择">
					<div class="select-btn-box">
						<el-button type="primary" size="mini" @click="allSelect('time')">全选</el-button>
						<el-button size="mini" @click="cancelSelect()">取消全选</el-button>
					</div>
					<el-option
						v-for="item in timeDate"
						:key="item.value"
						:label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-tooltip>
			<el-input v-model="orderGoodsDate[0]" placeholder="请输入内容" type="Number" @input="()=>{orderGoodsDate[0] = orderGoodsDate[0].replace(/[^\d]/g, '')}" size="small" v-if="type === '0' && orderGoodsType === 3" style="width:120px;margin-left:20px;"></el-input>
		</div>
		<div class="input-box" v-show="type === '1'">
			<span>修改为：</span>
			<el-radio v-model="orderGoodsTimeFlag" :label="0">不限制</el-radio>
			<el-radio v-model="orderGoodsTimeFlag" :label="1">订货时间</el-radio>
			<div class="time-list" v-if="orderGoodsTimeFlag === 1">
				<div class="time-box" v-for="(item, index) in times" :key="index">
					<el-time-picker
						size="small"
						v-model="item.beginTime"
						value-format="HH:mm"
						format="HH:mm"
						placeholder="开始时间"
						:picker-options="{
							selectableRange: `00:00:00 - 23:59:00`
						}">
					</el-time-picker>
					<div class="time-split">至</div>
					<el-time-picker
						size="small"
						v-model="item.endTime"
						value-format="HH:mm"
						format="HH:mm"
						placeholder="结束时间"
						:picker-options="{
							selectableRange: `00:00:00 - 23:59:00`
						}">
					</el-time-picker>
					<span class="next-day-tip">{{ isNextDayTime(item) ? '次日' : '' }}</span>
					<el-button
						size="mini"
						class="time-btn"
						icon="el-icon-minus"
						circle
						:disabled="times.length === 1"
						@click="removeTime(index)">
					</el-button>
					<el-button
						v-if="index === times.length - 1"
						size="mini"
						class="time-btn"
						icon="el-icon-plus"
						circle
						:disabled="times.length >= maxTimeCount"
						@click="addTime">
					</el-button>
				</div>
			</div>
		</div>
		<div class="input-box nohave-box" v-show="type === '0' && orderGoodsType === 2">
			<div>
				<el-tooltip effect="dark" placement="top" popper-class="tip-class">
					<div slot="content">当填写不包括内容时，优先级更高；如每月固定日选了30，31两天，<br/>不包括选择月末最后2天，当前月份为31天时，30，31两天买家不可订货</div>
					<div>
						<img src="~/images/icon/tooltip-icon.png" class="tip-icon" width="14" height="14">
					</div>
				</el-tooltip>不包括：
			</div>
			<el-select
				v-model="unflag"
				size="small">
				<el-option
					label="无"
					value="0">
				</el-option>
				<el-option
					label="月末最后"
					value="1">
				</el-option>
			</el-select>
			<div v-if="type === '0' && unflag === '1'" style="display:inline-block">
				<el-input v-model="unordergoodsdate" placeholder="请输入内容" type="Number" @input="dateInput" size="small" style="width:150px;margin-left:20px;"></el-input> 天
			</div>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button size='small' type='primary' class="fx-big-btn" plain @click="cancel">取消</el-button>
			<el-button size='small' type='primary' class="fx-big-btn" plain @click="saveBatch">保存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'editModal',
	props: {
		ids: Array,
		tableData: Array
	},
	data () {
		return {
			type: '0',
			orderGoodsType: 0,
			orderGoodsTimeFlag: 0,
			orderGoodsDate: [],
			maxTimeCount: 3,
			times: [{
				beginTime: '00:00',
				endTime: '23:59'
			}],
			weekDate: [
				{ label: '周一', value: '一' },
				{ label: '周二', value: '二' },
				{ label: '周三', value: '三' },
				{ label: '周四', value: '四' },
				{ label: '周五', value: '五' },
				{ label: '周六', value: '六' },
				{ label: '周日', value: '日' }
			],
			weekTooltip: '',
			timeDate: this.initTimeDate(),
			timeTooltip: '',
			monthEndFlag: 0,
			unflag: '0',
			unordergoodsdate: ''
		}
	},
	watch: {
		type () {
			this.monthEndFlag = 0
			this.orderGoodsType = 0
			this.orderGoodsTimeFlag = 0
			this.orderGoodsDate = []
			this.weekTooltip = ''
			this.timeTooltip = ''
			this.unflag = '0'
			this.unordergoodsdate = ''
			this.times = [this.getDefaultTime()]
		},
		orderGoodsType () {
			this.orderGoodsDate = []
			this.weekTooltip = ''
			this.timeTooltip = ''
		}
	},
	methods: {
		getDefaultTime () {
			return {
				beginTime: '00:00',
				endTime: '23:59'
			}
		},
		addTime () {
			if (this.times.length >= this.maxTimeCount) {
				return
			}
			this.times.push({
				beginTime: '',
				endTime: ''
			})
		},
		removeTime (index) {
			if (this.times.length <= 1) {
				return
			}
			this.times.splice(index, 1)
		},
		isNextDayTime (item) {
			if (!item || !item.beginTime || !item.endTime) {
				return false
			}
			const begin = item.beginTime.split(':')
			const end = item.endTime.split(':')
			const beginMinutes = parseInt(begin[0]) * 60 + parseInt(begin[1])
			const endMinutes = parseInt(end[0]) * 60 + parseInt(end[1])
			return endMinutes < beginMinutes
		},
		formatOrderTimeRange (item) {
			if (item.beginTime && item.endTime) {
				if (this.isNextDayTime(item)) {
					return `${item.beginTime}-次日${item.endTime}`
				}
				return `${item.beginTime}-${item.endTime}`
			}
			return `${item.beginTime || ''}-${item.endTime || ''}`
		},
		getOrderTimeList (data) {
			if (data.times && data.times.length) {
				return data.times
			}
			return [{
				beginTime: data.beginTime,
				endTime: data.endTime
			}]
		},
		initTimeDate () {
			let timeData = []
			for (let index = 1; index < 32; index++) {
				let item = {
					value: index, label: String(index)
				}
				timeData.push(item)
			}
			timeData.push({
				value: 32,
				label: '月末最后一天'
			})
			return timeData
		},
		allSelect (val) {
			if (val === 'week') {
				this.orderGoodsDate = ['一', '二', '三', '四', '五', '六', '日']
				this.selectWeek()
			} else if (val === 'time') {
				let arr = new Array(33)
				let i = arr.length
				while (i--) {
					if (i === 0) {
						break
					}
					arr[i] = i
				}
				this.orderGoodsDate = arr
				this.selectTime()
			}
		},
		dateInput () {
			this.unordergoodsdate = this.unordergoodsdate.replace(/[^0-9]/g, '')
		},
		cancelSelect () {
			this.orderGoodsDate = []
			this.weekTooltip = ''
			this.timeTooltip = ''
		},
		selectTime () {
			this.orderGoodsDate.sort((a, b) => {
				return a - b
			})
			let orderGoodsDate = JSON.parse(JSON.stringify(this.orderGoodsDate))
			orderGoodsDate.forEach((item, index) => {
				if (item === 32) {
					orderGoodsDate[index] = '月末最后一天'
				}
			})
			this.timeTooltip = orderGoodsDate.join('，')
			// console.log(this.orderGoodsDate)
		},
		selectWeek () {
			let orderGoodsDate = []
			this.sortWeek(this.orderGoodsDate).forEach(item => {
				orderGoodsDate.push(('周' + item.value))
			})
			this.weekTooltip = orderGoodsDate.join('，')
			// console.log(this.orderGoodsDate)
		},
		sortWeek (date) {
			let weekMap = date.map(item => {
				return {
					num: this.transferData(item),
					value: item
				}
			})
			weekMap.sort(function (a, b) {
				return (a.num - b.num)
			})
			return weekMap
		},
		transferData (data) {
			switch (data) {
			case '一':
				return 1
			case '二':
				return 2
			case '三':
				return 3
			case '四':
				return 4
			case '五':
				return 5
			case '六':
				return 6
			case '日':
				return 7
			}
		},
		saveBatch () {
			if (this.orderGoodsDate.length === 0 && this.orderGoodsType !== 0 && this.type === '0') {
				this.$message.error('请选择订货周期！')
				return false
			}
			if (this.type === '0' && this.orderGoodsType === 2 && this.unflag === '1' && !this.unordergoodsdate) {
				this.$message.error('请输入天数！')
				return false
			}
			if (this.type === '0' && this.orderGoodsType === 2 && this.unflag === '1' && +this.unordergoodsdate > 31) {
				this.$message.error('天数最大值为31！')
				return false
			}
			if (this.type === '1' && this.orderGoodsTimeFlag === 1) {
				const incomplete = this.times.some(item => !item.beginTime || !item.endTime)
				if (incomplete) {
					this.$message.error('请选择完整的订货时间！')
					return false
				}
			}
			// console.log(this.ids)
			let ids = this.ids.map(item => {
				return item.id
			})
			this.monthEndFlag = this.orderGoodsDate.includes(32) ? 1 : 0
			let orderGoodsDate = JSON.parse(JSON.stringify(this.orderGoodsDate))
			orderGoodsDate.forEach((item, index) => {
				if (item === 32) {
					orderGoodsDate.splice(index, 1)
				}
			})
			let paramsOrderGoodsDate = 	orderGoodsDate.join(',')
			let params = {
				ids,
				type: +this.type,
				orderGoodsType: this.orderGoodsType,
				orderGoodsDate: paramsOrderGoodsDate,
				monthEndFlag: this.monthEndFlag,
				orderGoodsTimeFlag: this.orderGoodsTimeFlag,
				times: this.times,
				unflag: this.unflag,
				unordergoodsdate: this.unordergoodsdate
			}
			let nameArr = []
			let msg = ''
			let logData = {
				orderGoodsType: this.orderGoodsType,
				orderGoodsDate: paramsOrderGoodsDate,
				monthEndFlag: this.monthEndFlag,
				orderGoodsTimeFlag: this.orderGoodsTimeFlag,
				times: this.times,
				unflag: this.unflag,
				unordergoodsdate: this.unordergoodsdate
			}
			this.ids.forEach(item => {
				let orderGoodsDate = this.orderGoodsTypeInit(item)
				let orderGoodsDate1 = this.orderGoodsTypeInit(logData)
				let orderGoodsTimeFlag = this.orderGoodsTimeFlagInit(item)
				let orderGoodsTimeFlag1 = this.orderGoodsTimeFlagInit(logData)
				let text = `【“客户：${item.customerName}”的“订货方案由${item.productName}，${item.shopName}，${orderGoodsDate}，${orderGoodsTimeFlag}”修改为${item.productName}，${item.shopName}，${orderGoodsDate1}，${orderGoodsTimeFlag1}】`
				nameArr.push(text)
			})
			msg = nameArr.join(',')
			let url = window.location.href.split('?')[0]
			url = url.replace(window.location.origin, '').substring(1)
			params.logMessage = {
				message: msg,
				referer: url
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/batchUpdateProductOrderGoodsDate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.$emit('cancel', 1)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		orderGoodsTimeFlagInit (data) {
			if (data.orderGoodsTimeFlag === 0) {
				return '不限制'
			}
			return this.getOrderTimeList(data).map(item => this.formatOrderTimeRange(item)).join('、')
		},
		orderGoodsTypeInit (data) {
			let text = ''
			switch (data.orderGoodsType) {
			case 0:
				text = '每天订货'
				break
			case 1:
				text = `每周${data.orderGoodsDate}订货`
				break
			case 2:
				text = `每月${data.orderGoodsDate}订货`
				if (data.monthEndFlag === 1) {
					text = text + ',每月月末最后一天订货'
				}
				if (+data.unflag === 1) {
					text = text + ',不包括月末最后' + data.unordergoodsdate + '天'
				}
				break
			case 3:
				text = `每隔${data.orderGoodsDate}天可订货`
				break
			}
			return text
		},
		cancel () {
			this.$emit('cancel', 0)
		}
	}
}
</script>
<style lang="stylus">
.el-time-panel {
	width: 120px !important
}
.el-select .el-tag__close.el-icon-close {
	top: 0
}
.time-box {
	.el-input {
		width: 120px
	}
}
</style>
<style lang="stylus" scoped>
span{
	margin-top :10px
}
.detail-box{
    padding 10px 20px 10px 20px
    display: flex;
    text-align:left ;
	flex-direction: column
    .input-box{
		text-align :left
		width :100%;
		margin-bottom:10px
		&.nohave-box {
			position: relative;
			display: flex;
			align-items: center;
		}
		.time-list {
			margin: 20px 0 0 56px
			.time-box {
				display: flex
				flex-flow: row
				align-items: center
				margin-bottom: 10px
				.time-split {
					margin: 0 12px
				}
				.next-day-tip {
					color: #f56c6c
					font-size: 12px
					margin-left: 10px
					font-weight: bold
					min-width: 28px
				}
				.time-btn {
					margin-left: 8px
					padding: 4px !important
				}
			}
		}
		/deep/ .el-select {
			width: 150px;
		}
		.name-input {
			width: 150px;
			margin-right: 10px;
		}
		.select-box{
			width:120px;
			margin-right:10px;
		}
		.el-radio {
			margin-top: 15px
		}
		.elect-btn-box {
			display: flex;
			flex-flow: row;
			justify-content: center;
			/deep/ .el-button-mini {
				height: 25px;
				display: flex;
				align-items: center;
			}
		}
	}
	.tip-icon {
		position: absolute;
		left: -20px;
		top: 10px;
		cursor: pointer;
	}
}
.dialog-footer{
    margin-top:20px;
    text-align:center;
	.el-button{
		margin-right :15px
	}
}
.box{
    width:500px;
	height :80px;
	margin-top:-40px
}
.text{
    width:70px;
}
.text1{
    height: 60px;
    line-height:20px;
    overflow-y:auto;
	padding-left:30px
}
.img-list{
	display :inline-block;
    flex-wrap:wrap;
    margin-bottom:10px
}
.img-box{
    margin-top:10px;
    margin-left:25px;
    height: 120px;
    width:120px
}
.radio-box{
	flex-direction: column;
	width:200px;
    margin-top: 10px
	.el-radio{
		margin-left :30px;
		margin-bottom :10px;
		span{
			font-size :12px
		}
	}
}
.rule{
	width :400px;
	margin-left :30px;
	margin-bottom :10px;
}
.reason-input{
	width :300px
}
.logo{
	width:100px;
    position :relative;
    left: 410px;
    top: -110px;
    .logo-img{
        width :100px;
        height :50px
    }
}
.reason-box{
	padding-left :30px;
	display:block;
    height :40px;
    line-height :40px
}
.isRed >>> .el-input__inner{
		color:red
	}
</style>
